import { doc, onSnapshot } from 'firebase/firestore'
import { auth, db } from '../../../firebase/config'
import '../../../global'
import { useEffect } from 'react'
import { DATABASE_NAME } from '@env'
import { useAppDispatch } from '../../../state/hooks'
import { setUserState } from '../../../state/Slices/userSlice'
import { serializeUserTimestamps } from '../getUserData'

const useUserListener = () => {
	const dispatch = useAppDispatch()

	useEffect(() => {
		// console.log('Setting up user listener')

		// Only set up listener if we have an authenticated user
		if (!auth.currentUser) {
			console.log('No authenticated user')
			return
		}

		// console.log('Setting up Firestore listener for user:', auth.currentUser.uid)
		// console.log('DATABASE_NAME', DATABASE_NAME)

		// Set up the document reference
		const docRef = doc(db, DATABASE_NAME, global.org, 'Customers', auth.currentUser.uid)

		const unsubscribe = onSnapshot(
			docRef,
			docSnapshot => {
				if (docSnapshot.exists()) {
					const userData = serializeUserTimestamps({ user: docSnapshot.data() })
					dispatch(
						setUserState({
							userData: userData,
						})
					)
				} else {
					console.log('Document does not exist')
				}
			},
			error => {
				console.error('Firestore listener error:', error)
			}
		)

		// Cleanup function
		return () => {
			console.log('Cleaning up user listener')
			unsubscribe()
		}
	}, [auth.currentUser?.uid, dispatch]) // Added auth.currentUser?.uid as dependency

	return null
}

export default useUserListener
